module.exports = __webpack_public_path__ + "static/media/product7.c32e12f7.png";